import { type GetBreadcrumbsRequest } from '@/modules/search/aliases';
import { getFiltersFromPath } from '@/modules/search/helpers/getFiltersFromPath';

export function buildCategoryBreadcrumbQueryParams(
  categoryPathname: string
): NonNullable<GetBreadcrumbsRequest> {
  const searchFiltersFromPath = getFiltersFromPath(categoryPathname);

  return {
    group: searchFiltersFromPath.groups,
    gender: searchFiltersFromPath.gender,
    is_kids: String(searchFiltersFromPath.isKids),
    product_type: searchFiltersFromPath.productTypes?.[0],
  };
}
